import { Injectable } from '@angular/core';

@Injectable()
export class ApiAuthorizationConfig {
  public authority: string;
  public clientId: string;
  public scope: string;
  public responseType: string;
}
